export interface ILoginService {
	requestLogin(tplName?: string): ng.IPromise<number>;
	currentMemberId(): number;
	logout(): ng.IHttpPromise<any>;
	// loginPromise: ng.IPromise<number>;
}

export enum LoginServiceEvents {
	LoggedIn = 'loginService:success'
}

export class LoginService implements ILoginService {
	public static $inject = [
		'$uibModal',
		'$q',
		'$rootScope',
		'$http',
	];

	protected previousLoggedInUser : number;
	// protected loginRequested = false;
	protected loginPromise: ng.IPromise<number>;
	// protected def;


	constructor(
		protected $uibModal : any,
		protected $q : ng.IQService,
		protected $rootScope: ng.IRootScopeService,
		protected $http: ng.IHttpService,
	) {
		if (window['LTConfiguration']&& window['LTConfiguration']['userId']) {
			this.previousLoggedInUser = window['LTConfiguration']['userId'];
			this.keepLoggedIn();
		}

		window['portalsLoginService'] = this;
		// let def = this.$q.defer<number>();
		// this.loginPromise = def.promise;
		// this.def = def;
	}

	protected keepingLoggedIn : boolean = false;

	/**
	 * Tries to keep the user logged in by requesting the logged in status
	 */
	protected keepLoggedIn() {
		if (this.keepingLoggedIn) return;
		
		let checkLoggedIn = () => {
			let path = document.location.pathname;
			if (path[path.length - 1] != '/') {
				path += '/';
			}
			this.$http.get('/home/loggedIn?c=' + (new Date()).getTime()).then((data: any) => {
				if (!data.data.user && !data.data.userId) {
					this.keepingLoggedIn = false;
					(window['LTConfiguration'] || {})['userId'] = null;
					this.requestLogin('LoggedOut');
				} else {
					window.setTimeout(checkLoggedIn, 60 * 1000); // Each minute
				}
			});
		};

		window.setTimeout(checkLoggedIn, 15 * 1000);
		this.keepingLoggedIn = true;
	}

    currentMemberId(): number {
        return window['LTConfiguration'] && window['LTConfiguration']['userId'];
    }

    logout(): angular.IHttpPromise<any> {
        let req =  this.$http.get('/Security/logout');

        req.then(() => {
            if (window['LTConfiguration']&& window['LTConfiguration']['userId']) {
            	delete window['LTConfiguration']['userId'];
			}
		});

        return req;
    }

	requestLogin(modal = 'Login'): angular.IPromise<number> {
		if (window['LTConfiguration']['userId']) {
			this.keepLoggedIn();
			return this.$q.resolve(window['LTConfiguration']['userId']);
		}

		if (!this.loginPromise) {
			const def = this.$q.defer<number>();
			this.loginPromise = def.promise;
			this.loginPromise.finally(() => {
				// clean up if we log in successfully
				delete this.loginPromise;
			});

			const backURL = window.location.pathname
				+ (window.location.search ? '?' + window.location.search : '');

			const uibModalInstance = this.$uibModal.open({
				animation: true,
				templateUrl: '/Partial/modal/' + modal + '?' + new URLSearchParams([['BackURL', backURL]]),
				controller: 'loginModalCtrl',
				size: 'md',
				// scope: $scope,
				appendTo: angular.element(document.querySelector('.fullscreen') || document.querySelector('body')),
				resolve: {
					/*items: function() {
                        return $scope.items
                    }*/
				}
			});

			// If the user successfully logs in, resolve with the MemberID
			uibModalInstance.result.then((result) => {
				try {
					let previousMember = this.previousLoggedInUser || window['LTConfiguration']['userId'];
					// let memberID = result.data['MemberID'];
					const {data} = result;
					const memberID = data.MemberID;
					console.log('login-service', result.data);
					// window['LTConfiguration']['userId'] = memberID;
					// window['LTConfiguration']['email'] = resu;
					window['LTConfiguration'] = {
						...window['LTConfiguration'],
						userId: memberID,
						email: data.Email,
						license: data.License,
						organisation: data.Organisation,
					}
					this.previousLoggedInUser = memberID;
					this.$rootScope.$broadcast(LoginServiceEvents.LoggedIn, memberID, previousMember);
					def.resolve(memberID);
				} catch (e) {
					def.reject(e);
					return;
				}

				this.keepLoggedIn();
				}, (reason) => def.reject(reason));
		}

		return this.loginPromise;
	}
}